<template>
  <div class="cc_ssc-block">
    <g-switch-list1
      :horizontal-type="2"
      :title="top1.title"
      :columns="4"
      :chip="chip"
      :list="top1.list"></g-switch-list1>

    <div class="clearBoth">
      <g-switch-list2
              class="cs-wrap"
              v-for="(innerList, index) in data.vertical"
              :key="'cc_ssc' + index"
              :list="innerList.list"
              :chip="chip"
              :title="innerList.title"
              :vertical-type="3"></g-switch-list2>
    </div>

    <g-switch-list1
            class="cs_horizontal"
            v-for="(inner, ind) in top_else"
            :key="'cc_' + ind"
            :chip="chip"
            :horizontal-type="2"
            :title="inner.title"
            :columns="5"
            :list="inner.list"></g-switch-list1>
  </div>
</template>

<script>
  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向
  import GSwitchList2 from '../../c_game-switch/switch-list/g_switch-2'; // 纵向
  export default {
    name: "cc_ssc-1",
    props: {
      chip: String,
      data: {
        type: Object,
        default() {
          return {
            vertical: [
            ],
            horizontal: [
            ]
          }
        }
      }
    },
    components: {
      GSwitchList1,
      GSwitchList2,
    },
    computed: {
      componentName () {
        return 1
      },
      top1 () {
        return this.data.horizontal[0] || {};
      },
      top_else () {
        return this.data.horizontal.slice(1) || [];
      }
    },
    data () {
      return {
        tabs: [
          {
            title: ''
          }
        ]
      }
    }
  }
</script>

<style scoped lang="stylus">
  .cc_ssc-block
    overflow hidden
    position relative
    .cs_horizontal{
      margin-top 7px
    }
    .cs-wrap
      width calc(20% - 5.6px)
      float left
      margin-top 7px
    .cs-wrap + .cs-wrap
      margin-left 7px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/cc_ssc/cc_ssc-1.vue